import { useMediaQuery, useTheme } from '@mui/material';
import { getMemberadminRoute } from '@dap/common/consts';
import {
  selectBrandKey,
  useAppDispatch,
  useSelectedBrandKey,
  useUser,
} from '@dap/common/data-access';
import { BrandSelectOption } from '@dap/common/ui';
import { useNavigate, useMatch } from 'react-router';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
import { LanguageCapitalLettersCode, LanguageCode } from '@shared/types';

export interface HeaderProps {
  switchLanguage: (languageCode: LanguageCapitalLettersCode) => void;
  language: LanguageCode;
  onLogout: () => void;
}

export default function Header({ switchLanguage, language, onLogout }: HeaderProps) {
  const navigate = useNavigate();
  const userData = useUser();
  const selectedBrandKey = useSelectedBrandKey();
  const dispatch = useAppDispatch();
  const isBrandAdminRoute = useMatch(`${getMemberadminRoute()}/*`);

  const selectBrand = (brandKey: string) => {
    dispatch(selectBrandKey(brandKey));
    if (isBrandAdminRoute) {
      navigate(getMemberadminRoute());
    } else navigate('/');
  };

  const brandOptions: BrandSelectOption[] = userData.brands.map((brand) => ({
    name: brand.name,
    key: brand.key,
  }));

  const { breakpoints } = useTheme();
  const enhanced = useMediaQuery(breakpoints.up('lg'));

  if (!userData) return null;

  if (enhanced) {
    return (
      <Desktop
        switchLanguage={switchLanguage}
        language={language}
        userData={userData}
        brands={brandOptions}
        selectedBrandKey={selectedBrandKey}
        onSelectBrand={selectBrand}
      />
    );
  }

  return (
    <Mobile
      userData={userData}
      brands={brandOptions}
      selectedBrandKey={selectedBrandKey}
      onSelectBrand={selectBrand}
      onLogout={onLogout}
    />
  );
}
